// ShareBite AI-suggestion final-category guard (Task 9.3).
//
// Pure, platform-independent guard ensuring the AI Classifier never determines
// a published Donation's Food Category. Whatever the Classifier returns — a
// Suggested Category with any Confidence Score, a timeout, an error, or
// unavailability — the final persisted Food Category equals the category the
// Restaurant explicitly confirmed or selected (Req 9.6, 9.7), and all
// Restaurant-entered Donation data is retained without loss (Req 10.4). The
// Classifier is not invoked when the Food Name or all images are absent
// (Req 9.3).
//
// The functions perform no I/O and have no side effects; the caller (the
// DonationEditor flow / DonationService) decides whether to invoke the
// Classifier and persists the finalized category and entered data.
//
// Design reference: design.md "Property 20: AI suggestion never determines
// final category".
// Requirements: 9.3, 9.5, 9.6, 9.7, 10.4.
/**
 * Decide whether the AI Classifier may be invoked (Req 9.3).
 *
 * Returns `true` if and only if a non-empty Food Name is present AND at least
 * one image is provided. When either is absent the Classifier MUST NOT be
 * invoked and the caller should surface the missing required input.
 *
 * Pure: reads only its argument and returns a boolean.
 */
export function shouldInvokeClassifier(inputs) {
    return inputs.foodName.length > 0 && inputs.imageRefs.length > 0;
}
/**
 * Finalize the Food Category for a Donation about to be published
 * (Req 9.5, 9.6, 9.7, 10.4).
 *
 * The returned `foodCategory` is always `input.confirmedCategory`, regardless
 * of `input.aiOutcome` — including any Suggested Category, any Confidence
 * Score, a timeout, an error, or unavailability. The Restaurant-entered data is
 * returned unchanged (the same reference is passed through), so no entered data
 * is lost.
 *
 * Pure: reads only its argument, mutates nothing, and produces no side effects.
 */
export function finalizeDonationCategory(input) {
    return {
        foodCategory: input.confirmedCategory,
        enteredData: input.enteredData,
    };
}
//# sourceMappingURL=aiGuard.js.map